import { useTranslation } from '@frontend/i18n';
import { Text, TextLink } from '@frontend/design-system';
import { AudienceTray } from '../audience-tray/audience-tray';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = {
  cancelFilters: () => void;
};

export const FiltersViewHeader = ({ cancelFilters }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { enableManualSelection, setMode, trackingIdPrefix } = useAudienceTray();
  return (
    <AudienceTray.Header
      title={enableManualSelection ? t('Filter Recipients List') : t('Create a Segment')}
      onBackClick={cancelFilters}
    >
      <Text color='subdued'>{t('Select the filters that describe the contacts you are targeting.')}</Text>
      <TextLink onClick={() => setMode('privacy')} trackingId={`${trackingIdPrefix}-privacy-rules-btn`}>
        {t('Privacy Rules')}
      </TextLink>
    </AudienceTray.Header>
  );
};
